import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import About from './pages/About/About';
import Home from './pages/Home/Home';

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
            </Routes>
        </BrowserRouter>
    );
}